export const initialState = {
  isReadOnly: false,
  header: {
    engineScoringId: null,
    name: '',
    code: '',
    version: 1,
    validFrom: null,
    validTo: null,
    defaultYN: false,
    active: true,
    targetContextId: null,
    docStructureKey: null,
    periodSelectionModeId: null,
    financialIndicatorDimensionCount: null,
    isHistory: false,
    evaluationOrder: null,
    displayOrder: null,
    partnerTypeFormula: null,
    initialCollectionPartnerTypes: [],
    partnerTypes: [],
    partnerTypeIds: [],
    initialCollectionPartnerBaseTypes: [],
    partnerBaseTypes: [],
    partnerBaseTypeIds: [],
    changed: false,
    saving: false
  },
  classifications: [],
  deletedItems: {
    attributes: [],
    categories: [],
    financialIndicators: [],
    evaluatedAttributes: [],
    intervals: [],
    rules: [],
    externalSystems: [],
    partnerTypes: [],
    partnerBaseTypes: []
  },
  intervals: {
    changed: false,
    saving: false,
    engineIntervals: []
  },
  rules: {
    changed: false,
    saving: false,
    engineRules: []
  },
  knockoutCriteria: [],
  externalSystems: {
    changed: false,
    saving: false,
    engineExternalSystems: []
  },
  evaluatedAttributes: {
    page: 0,
    pageSize: 10,
    totalCount: 0,
    pagination: [],
    allAttributes: [],
    useAllAttributes: true,
    initialCollectionEvaluatedAttributes: [],
    changed: false,
    saving: false
  }
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);

    //#region Save
    case 'OnHeaderSaved':
      return onHeaderSaved(state);
    case 'OnClassificationSaved':
      return onClassificationSaved(state, action);
    case 'OnEvaluatedAttributesSaved':
      return onEvaluatedAttributesSaved(state, action);
    case 'OnEngineScoringIntervalsSaved':
      return onEngineScoringIntervalsSaved(state);
    case 'OnEngineScoringRulesSaved':
      return onEngineScoringRulesSaved(state);
    case 'OnEngineExternalSystemsSaved':
      return onEngineExternalSystemsSaved(state);
    case 'OnKnockoutCriterionSaved':
      return onKnockoutCriterionSaved(state, action);
    //#endregion

    //#region OnPropertyChange
    case 'OnHeaderPropertyChanged':
      return onHeaderPropertyChanged(state, action);
    case 'OnExecutionOrderChanged':
      return OnExecutionOrderChanged(state, action);
    case 'OnClassificationHeaderChanged':
      return onClassificationHeaderChanged(state, action);
    case 'OnClassificationCategoryChanged':
      return onClassificationCategoryChanged(state, action);
    case 'OnClassificationAttributeChanged':
      return onClassificationAttributeChanged(state, action);
    case 'OnClassificationFinancialIndicatorChanged':
      return onClassificationFinancialIndicatorChanged(state, action);
    case 'OnEngineScoringKnockoutCriterionPropertyChanged':
      return onEngineScoringKnockoutCriterionPropertyChanged(state, action);
    case 'OnUseAllAttributesChanged':
      return onUseAllAttributesChanged(state, action);
    case 'OnEngineIntervalChanged':
      return onEngineIntervalChanged(state, action);
    case 'OnEngineRuleChanged':
      return onEngineRuleChanged(state, action);
    case 'OnEngineExternalSystemChanged':
      return onEngineExternalSystemChanged(state, action);
    //#endregion

    //#region OnAdd
    case 'OnAddEngineScoring':
      return onAddEngineScoring();
    case 'OnAddNewClassification':
      return onAddNewClassification(state);
    case 'OnAddNewClassificationCategory':
      return onAddNewClassificationCategory(state, action);
    case 'OnAddNewClassificationAttribute':
      return onAddNewClassificationAttribute(state, action);
    case 'OnAddNewClassificationFinancialIndicator':
      return onAddNewClassificationFinancialIndicator(state, action);
    case 'OnAddNewEvaluatedAttribute':
      return onAddNewEvaluatedAttribute(state, action);
    case 'OnAddAllAttributesForEvaluation':
      return onAddAllAttributesForEvaluation(state, action);
    case 'OnAddNewEngineInterval':
      return onAddNewEngineInterval(state);
    case 'OnAddNewEngineRule':
      return onAddNewEngineRule(state);
    case 'OnAddNewEngineExternalSystem':
      return onAddNewEngineExternalSystem(state);
    case 'OnAddNewKnockoutCriterion':
      return onAddNewKnockoutCriterion(state);
    //#endregion

    //#region OnDelete
    case 'OnClassificationCategoryDeleted':
      return onClassificationCategoryDeleted(state, action);
    case 'OnClassificationAttributeDeleted':
      return onClassificationAttributeDeleted(state, action);
    case 'OnClassificationDeleted':
      return onClassificationDeleted(state, action);
    case 'OnKnockoutCriterionDeleted':
      return onKnockoutCriterionDeleted(state, action);
    case 'OnClassificationFinancialIndicatorDeleted':
      return onClassificationFinancialIndicatorDeleted(state, action);
    case 'OnDeleteEvaluatedAttribute':
      return onDeleteEvaluatedAttribute(state, action);
    case 'OnDeleteAllEvaluatedAttributes':
      return onDeleteAllEvaluatedAttributes(state, action);
    case 'OnEngineIntervalDeleted':
      return onEngineIntervalDeleted(state, action);
    case 'OnEngineRuleDeleted':
      return onEngineRuleDeleted(state, action);
    case 'OnEngineExternalSystemDeleted':
      return onEngineExternalSystemDeleted(state, action);
    //#endregion

    //#region BeforeSaving
    case 'BeforeSavingHeader':
      return beforeSavingHeader(state);
    case 'BeforeSavingEvaluatedAttributes':
      return beforeSavingEvaluatedAttributes(state);
    case 'BeforeSavingEngineIntervals':
      return beforeSavingEngineIntervals(state);
    case 'BeforeSavingEngineRules':
      return beforeSavingEngineRules(state);
    case 'BeforeSavingEngineExternalSystems':
      return beforeSavingEngineExternalSystems(state);
    case 'BeforeSavingClassification':
      return beforeSavingClassification(state, action);
    case 'BeforeSavingKnockoutCriterion':
      return beforeSavingKnockoutCriterion(state, action);
    //#endregion

    //#region Others
    case 'UpdatePageEvaluatedAttributes':
      return updatePageEvaluatedAttributes(state, action);
    case 'OnKnockoutCriterionExpanded':
      return onKnockoutCriterionExpanded(state, action);
    //#endregion

    default:
      return state;
  }
};

const onInitState = (state, action) => {
  const {
    classifications,
    intervals,
    rules,
    knockoutCriteria,
    externalSystems,
    evaluatedAttributes,
    partnerTypes,
    partnerBaseTypes,
    ...rest
  } = action.engineScoring;

  const { useAllAttributes, ...header } = rest;
  return {
    ...state,
    header: {
      ...state.header,
      ...header,
      partnerTypes,
      initialCollectionPartnerTypes: partnerTypes,
      partnerBaseTypes,
      initialCollectionPartnerBaseTypes: partnerBaseTypes,
      partnerTypeIds: partnerTypes.map(x => x.partnerTypeId),
      partnerBaseTypeIds: partnerBaseTypes.map(x => x.partnerBaseTypeId)
    },
    classifications: classifications.map(x => ({ changed: false, saving: false, ...x })),
    intervals: {
      ...state.intervals,
      engineIntervals: intervals
    },
    rules: {
      ...state.rules,
      engineRules: rules
    },
    knockoutCriteria: knockoutCriteria.map(x => {
      return { ...x, isExpanded: false };
    }),
    externalSystems: {
      ...state.externalSystems,
      engineExternalSystems: externalSystems
    },
    evaluatedAttributes: {
      ...state.evaluatedAttributes,
      useAllAttributes: useAllAttributes,
      totalCount: evaluatedAttributes.length,
      allAttributes: evaluatedAttributes,
      initialCollectionEvaluatedAttributes: evaluatedAttributes,
      pagination: pagination(evaluatedAttributes, state.evaluatedAttributes.pageSize, state.evaluatedAttributes.page)
    }
  };
};

const onAddEngineScoring = () => {
  return Object.assign({}, initialState);
};

const onHeaderPropertyChanged = (state, action) => {
  const { property, propertyValue } = action.payload;

  let payload = {
    ...state,
    header: {
      ...state.header,
      [property]: propertyValue,
      changed: true
    }
  };

  if (property === 'partnerTypeIds') {
    payload = {
      ...state,
      header: {
        ...state.header,
        partnerTypeIds: propertyValue,
        partnerTypes: propertyValue.map(x => {
          return {
            id: null,
            engineScoringId: state.header.engineScoringId,
            partnerTypeId: x
          };
        }),
        partnerBaseTypeIds: [],
        partnerBaseTypes: [],
        partnerTypeFormula: null,
        changed: true
      },
      deletedItems: {
        ...state.deletedItems,
        partnerTypes: [
          ...state.header.initialCollectionPartnerTypes
            .filter(x => !propertyValue.map(y => y.partnerTypeId).includes(x.partnerTypeId))
            .map(x => x.id)
        ]
      }
    };
  }

  if (property === 'partnerBaseTypeIds') {
    payload = {
      ...state,
      header: {
        ...state.header,
        partnerBaseTypeIds: propertyValue,
        partnerBaseTypes: propertyValue.map(x => {
          return {
            id: null,
            engineScoringId: state.header.engineScoringId,
            partnerBaseTypeId: x
          };
        }),
        partnerTypeIds: [],
        partnerTypes: [],
        partnerTypeFormula: null,
        changed: true
      },
      deletedItems: {
        ...state.deletedItems,
        partnerBaseTypes: [
          ...state.header.initialCollectionPartnerBaseTypes
            .filter(x => !propertyValue.map(y => y.partnerBaseTypeId).includes(x.partnerBaseTypeId))
            .map(x => x.id)
        ]
      }
    };
  }

  if (property === 'filterTypeId') {
    payload = {
      ...state,
      header: {
        ...state.header,
        filterTypeId: propertyValue,
        partnerTypeIds: [],
        partnerTypes: [],
        partnerBaseTypeIds: [],
        partnerBaseTypes: [],
        partnerTypeFormula: null,
        changed: true
      }
    };
  }

  return {
    ...state,
    ...payload
  };
};

const OnExecutionOrderChanged = (state, action) => {
  const { property, propertyValue, index } = action;

  return {
    ...state,
    evaluatedAttributes: {
      ...state.evaluatedAttributes,
      changed: true,
      allAttributes: Object.assign([...state.evaluatedAttributes.allAttributes], {
        [index]: {
          ...state.evaluatedAttributes.allAttributes[index],
          [property]: propertyValue
        }
      }),
      pagination: pagination(
        Object.assign([...state.evaluatedAttributes.allAttributes], {
          [index]: {
            ...state.evaluatedAttributes.allAttributes[index],
            [property]: propertyValue
          }
        }),
        state.evaluatedAttributes.pageSize,
        state.evaluatedAttributes.page
      )
    }
  };
};

const onHeaderSaved = state => {
  return {
    ...state,
    header: {
      ...state.header,
      changed: false,
      saving: false
    }
  };
};

const onKnockoutCriterionDeleted = (state, action) => {
  const { index } = action;
  var knockoutCriteria = [...state.knockoutCriteria];
  knockoutCriteria.splice(index, 1);

  return {
    ...state,
    knockoutCriteria
  };
};

const onClassificationDeleted = (state, action) => {
  const { engineClassificationIndex } = action;

  var classifications = [...state.classifications];
  classifications.splice(engineClassificationIndex, 1);

  return {
    ...state,
    classifications
  };
};

const onEngineScoringKnockoutCriterionPropertyChanged = (state, action) => {
  const { property, propertyValue, index } = action;
  return {
    ...state,
    knockoutCriteria: Object.assign([...state.knockoutCriteria], {
      [index]: {
        ...state.knockoutCriteria[index],
        [property]: propertyValue,
        changed: true
      }
    })
  };
};

const onClassificationHeaderChanged = (state, action) => {
  const { property, propertyValue, classificationIndex } = action;
  return {
    ...state,
    classifications: Object.assign([...state.classifications], {
      [classificationIndex]: {
        ...state.classifications[classificationIndex],
        [property]: propertyValue,
        changed: true
      }
    })
  };
};

const onAddNewClassification = state => {
  const newClassification = {
    engineScoringClassificationId: null,
    engineScoringClassificationName: 'NEW CLASSIFICATION',
    engineScoringId: state.header.engineScoringId,
    orderNo:
      state && state.classifications && state.classifications.length > 0
        ? Math.max.apply(
            Math,
            state.classifications.map(item => item.orderNo)
          ) + 1
        : 1,
    visibleYN: false,
    linkedRuleId: null,
    displayPageId: null,
    attributes: [],
    categories: [],
    financialIndicators: [],
    changed: false
  };

  var classifications = [...state.classifications];
  classifications.push(newClassification);

  return {
    ...state,
    classifications
  };
};

const onAddNewClassificationCategory = (state, action) => {
  const { classificationIndex } = action;

  const newCategory = {
    engineScoringClassificationXScoringId: null,
    scoringId: null,
    scoringName: null,
    orderNo:
      state && state.classifications[classificationIndex].categories && state.classifications[classificationIndex].categories.length > 0
        ? Math.max.apply(
            Math,
            state.classifications[classificationIndex].categories.map(item => item.orderNo)
          ) + 1
        : 1,
    readOnlyCategory: false,
    isMandatory: false,
    engineScoringClassificationId: state.classifications[classificationIndex].engineScoringClassificationId
  };

  var newClassificationCategories = [...state.classifications[classificationIndex].categories];
  newClassificationCategories.push({ ...newCategory });

  return {
    ...state,
    classifications: Object.assign([...state.classifications], {
      [classificationIndex]: {
        ...state.classifications[classificationIndex],
        categories: newClassificationCategories
      }
    })
  };
};

const onAddAllAttributesForEvaluation = (state, action) => {
  let { allEngineAttributeOptions } = action;

  allEngineAttributeOptions = allEngineAttributeOptions.map(x => {
    return {
      engineScoringXAttributeId: null,
      engineScoringId: state.header.engineScoringId,
      engineAttributeId: x.engineAttributeId,
      executionOrder: 0,
      engineAttribute: { ...x }
    };
  });

  let allEvaluatedAttributes = [...state.evaluatedAttributes.allAttributes];
  allEvaluatedAttributes = [...allEngineAttributeOptions, ...allEvaluatedAttributes];

  return {
    ...state,
    evaluatedAttributes: {
      ...state.evaluatedAttributes,
      allAttributes: allEvaluatedAttributes,
      totalCount: allEvaluatedAttributes.length,
      changed: true,
      pagination: pagination(allEvaluatedAttributes, state.evaluatedAttributes.pageSize, state.evaluatedAttributes.page)
    }
  };
};

const onUseAllAttributesChanged = (state, action) => {
  const { propertyValue } = action;

  return {
    ...state,
    evaluatedAttributes: {
      ...state.evaluatedAttributes,
      useAllAttributes: propertyValue,
      changed: true
    }
  };
};

const onDeleteAllEvaluatedAttributes = state => {
  const allSavedEvaluatedAttributes = [...state.evaluatedAttributes.allAttributes]
    .filter(x => x.engineScoringXAttributeId !== null)
    .map(x => x.engineScoringXAttributeId);

  let mergeDeletedItemsArray = [...state.deletedItems.evaluatedAttributes, ...allSavedEvaluatedAttributes];

  return {
    ...state,
    evaluatedAttributes: {
      ...state.evaluatedAttributes,
      allAttributes: [],
      totalCount: 0,
      changed: true,
      pagination: pagination([], state.evaluatedAttributes.pageSize, state.evaluatedAttributes.page)
    },
    deletedItems: {
      ...state.deletedItems,
      evaluatedAttributes: mergeDeletedItemsArray
    }
  };
};

const onEngineExternalSystemDeleted = (state, action) => {
  const { engineScoringXExternalSystemId, index } = action;
  let newEngineExternalSystems = [...state.externalSystems.engineExternalSystems];
  newEngineExternalSystems.splice(index, 1);

  let deletedItemsExternalSystems = [...state.deletedItems.externalSystems];
  if (engineScoringXExternalSystemId && !deletedItemsExternalSystems.includes(engineScoringXExternalSystemId)) {
    deletedItemsExternalSystems.push(engineScoringXExternalSystemId);
  }

  return {
    ...state,
    externalSystems: {
      changed: true,
      engineExternalSystems: newEngineExternalSystems
    },
    deletedItems: {
      ...state.deletedItems,
      externalSystems: deletedItemsExternalSystems
    }
  };
};

const onEngineRuleDeleted = (state, action) => {
  const { engineRuleId, index } = action;

  let newEngineRules = [...state.rules.engineRules];
  newEngineRules.splice(index, 1);

  let deletedItemsRules = [...state.deletedItems.rules];
  if (engineRuleId && !deletedItemsRules.includes(engineRuleId)) {
    deletedItemsRules.push(engineRuleId);
  }

  return {
    ...state,
    rules: {
      changed: true,
      engineRules: newEngineRules
    },
    deletedItems: {
      ...state.deletedItems,
      rules: deletedItemsRules
    }
  };
};

const onEngineIntervalDeleted = (state, action) => {
  const { engineIntervalId, index } = action;

  let newEngineIntervals = [...state.intervals.engineIntervals];
  newEngineIntervals.splice(index, 1);

  let deletedItemsIntervals = [...state.deletedItems.intervals];
  if (engineIntervalId && !deletedItemsIntervals.includes(engineIntervalId)) {
    deletedItemsIntervals.push(engineIntervalId);
  }

  return {
    ...state,
    intervals: {
      changed: true,
      engineIntervals: newEngineIntervals
    },
    deletedItems: {
      ...state.deletedItems,
      intervals: deletedItemsIntervals
    }
  };
};

const onDeleteEvaluatedAttribute = (state, action) => {
  const { engineAttributeId, engineScoringXAttributeId } = action;

  let allEvaluatedAttributes = [...state.evaluatedAttributes.allAttributes].filter(x => x.engineAttributeId !== engineAttributeId);

  let deletedItemsAttributes = [...state.deletedItems.evaluatedAttributes];
  if (engineScoringXAttributeId && !deletedItemsAttributes.includes(engineScoringXAttributeId)) {
    deletedItemsAttributes.push(engineScoringXAttributeId);
  }

  return {
    ...state,
    evaluatedAttributes: {
      ...state.evaluatedAttributes,
      allAttributes: allEvaluatedAttributes,
      totalCount: allEvaluatedAttributes.length,
      changed: true,
      pagination: pagination(allEvaluatedAttributes, state.evaluatedAttributes.pageSize, state.evaluatedAttributes.page)
    },
    deletedItems: {
      ...state.deletedItems,
      evaluatedAttributes: deletedItemsAttributes
    }
  };
};

const onAddNewEvaluatedAttribute = (state, action) => {
  const { engineAttribute } = action;

  const index = state.evaluatedAttributes.allAttributes.findIndex(x => x.engineAttributeId === engineAttribute.engineAttributeId);

  if (index !== -1) {
    return state;
  }

  let newEngineAttribute = {
    engineScoringXAttributeId: null,
    engineScoringId: state.header.engineScoringId,
    engineAttributeId: engineAttribute.engineAttributeId,
    executionOrder: 0,
    engineAttribute: { ...engineAttribute }
  };

  const indexSavedAttribute = state.evaluatedAttributes.initialCollectionEvaluatedAttributes.findIndex(
    x => x.engineAttributeId === engineAttribute.engineAttributeId
  );

  if (indexSavedAttribute !== -1) {
    newEngineAttribute = { ...state.evaluatedAttributes.initialCollectionEvaluatedAttributes[indexSavedAttribute] };
  }

  let allEvaluatedAttributes = [...state.evaluatedAttributes.allAttributes];
  allEvaluatedAttributes = [newEngineAttribute].concat(allEvaluatedAttributes);

  return {
    ...state,
    evaluatedAttributes: {
      ...state.evaluatedAttributes,
      allAttributes: allEvaluatedAttributes,
      totalCount: allEvaluatedAttributes.length,
      changed: true,
      pagination: pagination(allEvaluatedAttributes, state.evaluatedAttributes.pageSize, state.evaluatedAttributes.page)
    }
  };
};

const onAddNewClassificationFinancialIndicator = (state, action) => {
  const { classificationIndex } = action;

  const newFinancialIndicator = {
    engineScoringClassificationXFinancialId: null,
    orderNo:
      state &&
      state.classifications[classificationIndex].financialIndicators &&
      state.classifications[classificationIndex].financialIndicators.length > 0
        ? Math.max.apply(
            Math,
            state.classifications[classificationIndex].financialIndicators.map(item => item.orderNo)
          ) + 1
        : 1,
    isMandatory: false,
    financialIndicatorId: '',
    financialIndicatorName: null,
    engineScoringClassificationId: state.classifications[classificationIndex].engineScoringClassificationId
  };

  var newClassificationFinancialIndicators = [...state.classifications[classificationIndex].financialIndicators];
  newClassificationFinancialIndicators.push({ ...newFinancialIndicator });

  return {
    ...state,
    classifications: Object.assign([...state.classifications], {
      [classificationIndex]: {
        ...state.classifications[classificationIndex],
        financialIndicators: newClassificationFinancialIndicators
      }
    })
  };
};

const onAddNewClassificationAttribute = (state, action) => {
  const { classificationIndex } = action;

  const newAttribute = {
    engineScoringClassificationXEngineAttributeId: null,
    engineAttributeId: null,
    description: null,
    orderNo:
      state && state.classifications[classificationIndex].attributes && state.classifications[classificationIndex].attributes.length > 0
        ? Math.max.apply(
            Math,
            state.classifications[classificationIndex].attributes.map(item => item.orderNo)
          ) + 1
        : 1,
    engineScoringClassificationId: state.classifications[classificationIndex].engineScoringClassificationId
  };

  var newClassificationAttributes = [...state.classifications[classificationIndex].attributes];
  newClassificationAttributes.push({ ...newAttribute });

  return {
    ...state,
    classifications: Object.assign([...state.classifications], {
      [classificationIndex]: {
        ...state.classifications[classificationIndex],
        attributes: newClassificationAttributes
      }
    })
  };
};

const onAddNewEngineInterval = state => {
  const newEngineInterval = {
    engineIntervalId: null,
    engineScoringId: state.header.engineScoringId,
    startsWith: null,
    endsWith: null,
    resultId: null
  };

  return {
    ...state,
    intervals: {
      changed: true,
      engineIntervals: [...state.intervals.engineIntervals, newEngineInterval]
    }
  };
};

const onAddNewEngineExternalSystem = state => {
  const newEngineExternalSystem = {
    engineScoringXExternalSystemId: null,
    engineScoringId: state.header.engineScoringId,
    externalSystemId: null,
    isMandatory: false
  };

  return {
    ...state,
    externalSystems: {
      changed: true,
      engineExternalSystems: [...state.externalSystems.engineExternalSystems, newEngineExternalSystem]
    }
  };
};

const onAddNewEngineRule = state => {
  const newEngineRule = {
    engineRuleId: null,
    engineScoringId: state.header.engineScoringId,
    number: null,
    name: null,
    expression: null
  };

  return {
    ...state,
    rules: {
      changed: true,
      engineRules: [...state.rules.engineRules, newEngineRule]
    }
  };
};

const onAddNewKnockoutCriterion = state => {
  const newEngineKnockoutCriterion = {
    engineScoringKnockoutCriteriaId: null,
    engineScoringId: state.header.engineScoringId,
    criteriaId: null,
    manualYN: true,
    aplicabilityFormula: null,
    titleFormula: null,
    resultFormula: null,
    isExpanded: true,
    changed: false
  };

  var knockoutCriteria = [...state.knockoutCriteria];
  knockoutCriteria.push(newEngineKnockoutCriterion);

  return {
    ...state,
    knockoutCriteria
  };
};

const onClassificationAttributeDeleted = (state, action) => {
  const { key, attributeIndex, classificationIndex } = action;

  const removedItem = state.classifications[classificationIndex].attributes[attributeIndex].engineScoringClassificationXEngineAttributeId;
  const deletedItems = [...state.deletedItems.attributes];

  let newClassificationAttributes = Object.assign([...state.classifications[classificationIndex].attributes]);
  newClassificationAttributes.splice(attributeIndex, 1);

  if (key) {
    deletedItems.push(removedItem);
  }

  return {
    ...state,
    classifications: Object.assign([...state.classifications], {
      [classificationIndex]: {
        ...state.classifications[classificationIndex],
        changed: true,
        attributes: newClassificationAttributes
      }
    }),
    deletedItems: { ...state.deletedItems, attributes: [...deletedItems] }
  };
};

const onClassificationCategoryDeleted = (state, action) => {
  const { key, categoryIndex, classificationIndex } = action;

  const removedItem = state.classifications[classificationIndex].categories[categoryIndex].engineScoringClassificationXScoringId;
  const deletedItems = [...state.deletedItems.categories];

  let newClassificationCategories = Object.assign([...state.classifications[classificationIndex].categories]);
  newClassificationCategories.splice(categoryIndex, 1);

  if (key) {
    deletedItems.push(removedItem);
  }

  return {
    ...state,
    classifications: Object.assign([...state.classifications], {
      [classificationIndex]: {
        ...state.classifications[classificationIndex],
        changed: true,
        categories: newClassificationCategories
      }
    }),
    deletedItems: { ...state.deletedItems, categories: [...deletedItems] }
  };
};

const onClassificationFinancialIndicatorDeleted = (state, action) => {
  const { key, financialIndicatorIndex, classificationIndex } = action;

  const removedItem =
    state.classifications[classificationIndex].financialIndicators[financialIndicatorIndex].engineScoringClassificationXFinancialId;
  const deletedItems = [...state.deletedItems.financialIndicators];

  let newClassificationFinancialIndicators = Object.assign([...state.classifications[classificationIndex].financialIndicators]);
  newClassificationFinancialIndicators.splice(financialIndicatorIndex, 1);

  if (key !== null) {
    deletedItems.push(removedItem);
  }

  return {
    ...state,
    classifications: Object.assign([...state.classifications], {
      [classificationIndex]: {
        ...state.classifications[classificationIndex],
        changed: true,
        financialIndicators: newClassificationFinancialIndicators
      }
    }),
    deletedItems: { ...state.deletedItems, financialIndicators: [...deletedItems] }
  };
};

const onClassificationCategoryChanged = (state, action) => {
  const { property, propertyValue, propertyName, propertyNameValue, categoryIndex, classificationIndex } = action;

  return {
    ...state,
    classifications: Object.assign([...state.classifications], {
      [classificationIndex]: {
        ...state.classifications[classificationIndex],
        changed: true,
        categories: Object.assign([...state.classifications[classificationIndex].categories], {
          [categoryIndex]: {
            ...state.classifications[classificationIndex].categories[categoryIndex],
            [property]: propertyValue,
            [propertyName]: propertyNameValue
          }
        })
      }
    })
  };
};

const onClassificationFinancialIndicatorChanged = (state, action) => {
  const { property, propertyValue, propertyName, propertyNameValue, financialIndicatorIndex, classificationIndex } = action;

  return {
    ...state,
    classifications: Object.assign([...state.classifications], {
      [classificationIndex]: {
        ...state.classifications[classificationIndex],
        changed: true,
        financialIndicators: Object.assign([...state.classifications[classificationIndex].financialIndicators], {
          [financialIndicatorIndex]: {
            ...state.classifications[classificationIndex].financialIndicators[financialIndicatorIndex],
            [property]: propertyValue,
            [propertyName]: propertyNameValue
          }
        })
      }
    })
  };
};

const onEngineExternalSystemChanged = (state, action) => {
  const { property, propertyValue, index } = action;

  return {
    ...state,
    externalSystems: {
      changed: true,
      engineExternalSystems: Object.assign([...state.externalSystems.engineExternalSystems], {
        [index]: {
          ...state.externalSystems.engineExternalSystems[index],
          [property]: propertyValue
        }
      })
    }
  };
};

const onEngineRuleChanged = (state, action) => {
  const { property, propertyValue, index } = action;

  return {
    ...state,
    rules: {
      changed: true,
      engineRules: Object.assign([...state.rules.engineRules], {
        [index]: {
          ...state.rules.engineRules[index],
          [property]: propertyValue
        }
      })
    }
  };
};

const onEngineIntervalChanged = (state, action) => {
  const { property, propertyValue, index } = action;

  return {
    ...state,
    intervals: {
      changed: true,
      engineIntervals: Object.assign([...state.intervals.engineIntervals], {
        [index]: {
          ...state.intervals.engineIntervals[index],
          [property]: propertyValue
        }
      })
    }
  };
};

const onClassificationAttributeChanged = (state, action) => {
  const { property, propertyValue, propertyDescription, propertyDescriptionValue, attributeIndex, classificationIndex } = action;

  return {
    ...state,
    classifications: Object.assign([...state.classifications], {
      [classificationIndex]: {
        ...state.classifications[classificationIndex],
        changed: true,
        attributes: Object.assign([...state.classifications[classificationIndex].attributes], {
          [attributeIndex]: {
            ...state.classifications[classificationIndex].attributes[attributeIndex],
            [property]: propertyValue,
            [propertyDescription]: propertyDescriptionValue
          }
        })
      }
    })
  };
};

const onKnockoutCriterionSaved = (state, action) => {
  const { index } = action;

  return {
    ...state,
    knockoutCriteria: Object.assign([...state.knockoutCriteria], {
      [index]: {
        ...state.knockoutCriteria[index],
        changed: false,
        saving: false
      }
    })
  };
};

const onClassificationSaved = (state, action) => {
  const { classificationIndex } = action;

  return {
    ...state,
    classifications: Object.assign([...state.classifications], {
      [classificationIndex]: {
        ...state.classifications[classificationIndex],
        changed: false,
        saving: false
      }
    })
  };
};

const onEngineExternalSystemsSaved = state => {
  return {
    ...state,
    externalSystems: {
      ...state.externalSystems,
      changed: false,
      saving: false
    },
    deletedItems: {
      ...state.deletedItems,
      externalSystems: []
    }
  };
};

const onEngineScoringRulesSaved = state => {
  return {
    ...state,
    rules: {
      ...state.rules,
      changed: false,
      saving: false
    },
    deletedItems: {
      ...state.deletedItems,
      rules: []
    }
  };
};

const onEngineScoringIntervalsSaved = state => {
  return {
    ...state,
    intervals: {
      ...state.intervals,
      changed: false,
      saving: false
    },
    deletedItems: {
      ...state.deletedItems,
      intervals: []
    }
  };
};

const onEvaluatedAttributesSaved = state => {
  return {
    ...state,
    evaluatedAttributes: {
      ...state.evaluatedAttributes,
      changed: false,
      saving: false
    },
    deletedItems: {
      ...state.deletedItems,
      sortedEvaluatedAttributes: []
    }
  };
};

const updatePageEvaluatedAttributes = (state, action) => {
  const { page, pageSize } = action;

  return {
    ...state,
    evaluatedAttributes: {
      ...state.evaluatedAttributes,
      page,
      pageSize,
      pagination: pagination(state.evaluatedAttributes.allAttributes, pageSize, page)
    }
  };
};

const beforeSavingHeader = state => {
  return {
    ...state,
    header: {
      ...state.header,
      saving: true
    }
  };
};

const beforeSavingEvaluatedAttributes = state => {
  return {
    ...state,
    evaluatedAttributes: {
      ...state.evaluatedAttributes,
      saving: true
    }
  };
};

const beforeSavingEngineIntervals = state => {
  return {
    ...state,
    intervals: {
      ...state.intervals,
      saving: true
    }
  };
};

const beforeSavingEngineRules = state => {
  return {
    ...state,
    rules: {
      ...state.rules,
      saving: true
    }
  };
};

const beforeSavingEngineExternalSystems = state => {
  return {
    ...state,
    externalSystems: {
      ...state.externalSystems,
      saving: true
    }
  };
};

const beforeSavingClassification = (state, action) => {
  const { classificationIndex } = action;
  return {
    ...state,
    classifications: Object.assign([...state.classifications], {
      [classificationIndex]: {
        ...state.classifications[classificationIndex],
        saving: true
      }
    })
  };
};

const beforeSavingKnockoutCriterion = (state, action) => {
  const { index } = action;
  return {
    ...state,
    knockoutCriteria: Object.assign([...state.knockoutCriteria], {
      [index]: {
        ...state.knockoutCriteria[index],
        saving: true
      }
    })
  };
};

const onKnockoutCriterionExpanded = (state, action) => {
  const { index, isExpanded } = action;
  return {
    ...state,
    knockoutCriteria: Object.assign([...state.knockoutCriteria], {
      [index]: {
        ...state.knockoutCriteria[index],
        isExpanded: isExpanded
      }
    })
  };
};

const pagination = (a, b, n) => {
  let current = n * b;
  const end = current + b;
  const items = a.slice(current, end);
  return items;
};
